import Vue from 'vue'
import EventBus from '@/event-bus'

Vue.directive('modal-trigger', {
  inserted: function (el, binding) {
    let modal = binding.value

    el.addEventListener('click', event => {
      EventBus.$emit(modal, true)
      const data = event.currentTarget.getAttribute('data-item') || null

      if (data) {
        EventBus.$emit(`${modal}Data`, JSON.parse(data))
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/directives/ModalTrigger.js